import styled from 'styled-components';
export const Card = styled.div `
  background-size: cover;
  background: url("${({ backgroundImage }) => backgroundImage}") center center;
  width: 100%;
  min-height: 42.6rem;
  border-radius: var(--border-radius-md);
  overflow: hidden;
  position: relative;
  padding: 2.5rem 2rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  
  .h2 {
    color: white;
  }
  
  .tags {
    z-index: 2;
    margin-bottom: auto;
    
    .tag {
      margin-bottom: 0;
    }
  }
  
  &::before {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(180deg, rgba(0, 91, 185, 0.3) 0%, #00356D 100%);
  }
`;
